// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FibeX","tabsBox":"styles_tabsBox__2wQ93","createButton":"styles_createButton__2wI_X"};